














import { Component, Prop } from "vue-property-decorator";

// Mixins
import { mixins } from "vue-class-component";
import { ImageProviderStore } from "@/mixins/imageProviderStore";

@Component
export default class ImageUploader extends mixins(ImageProviderStore) {
  @Prop({ default: null })
  public name!: string;

  @Prop({ default: 100 })
  public size!: string;

  @Prop({ default: true })
  public uploadable!: boolean;

  @Prop({ default: true })
  public removable!: boolean;

  @Prop({ default: false })
  public clickable!: boolean;
}
